import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Sgke071aRequest, Sgke071aResponseGamenHyojiInfo } from 'sg-api';
import { UsedSgke071aService } from '../../services/used-sgke071a.service';
import { UsedSgke072aService } from '../../services/used-sgke072a.service';

@Component({
  selector: 'app-sgke070d-regist',
  templateUrl: './sgke070d-regist.component.html',
  styleUrl: './sgke070d-regist.component.scss'
})
export class Sgke070dRegistComponent implements OnInit, OnDestroy {

  /** 未精算金管理番号 */
  @Input() kinkoMno: string;
  /** 未精算金履歴番号 */
  @Input() kinkoRrkno: string;
  /** 未精算金_更新通番号 */
  @Input() kinkoUpdateSrno: string;
  /** 未精算金EX_更新通番号 */
  @Input() kinkoexUpdatesequencenumber: string;
  /** 未精算ステータスコード */
  @Input() kinkoStatuscode: string;

  /** メッセージエミッター */
  @Output() msgEmit = new EventEmitter();
  /** エラーメッセージエミッター */
  @Output() errorMessageEmit = new EventEmitter();
  /** 通常メッセージエミッター */
  @Output() normalMessageEmit = new EventEmitter();
  /** メッセージエリアクリアエミッター */
  @Output() clearMessageEmit = new EventEmitter();
  /** SGKE020D再描画（再検索）エミッター */
  @Output() searchEmit = new EventEmitter();

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** 初期表示APIリクエスト */
  private request071a: Sgke071aRequest;
  /** 初期表示APIレスポンス_画面表示情報 */
  gamenHyojiInfo: Sgke071aResponseGamenHyojiInfo;

  /** 充当登録Form FormGroup */
  sgke072aRequestForm: UntypedFormGroup;
  /** 登録情報 */
  reginf: UntypedFormGroup;

  /** 次回請求予定日 */
  jikaiClaimPlndate: Date;

  /**
   * コンストラクタ
   * @param {TimeApiService} timeApiService
   * @param {UntypedFormBuilder} fb
   * @param {UsedSgke071aService} searchService
   * @param {UsedSgke072aService} registService
   * @memberof Sgke070dRegistComponent
   */
  constructor(
    private timeApiService: TimeApiService,
    private fb: UntypedFormBuilder,
    public searchService: UsedSgke071aService,
    public registService: UsedSgke072aService,
  ) { }

  /**
   * 初期処理
   * @memberof Sgke070dRegistComponent
   */
  ngOnInit() {
    // フォームを作成
    this.createForm();

    // 初期検索実行
    this.onInitSearch();
  }

  /**
   * 終了処理
   * @memberof Sgke070dRegistComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.sgke072aRequestForm.clearValidators();
    this.sgke072aRequestForm.updateValueAndValidity();
  }

  /**
   * フォーム作成
   * @memberof Sgke070dRegistComponent
   */
  private createForm() {
    // 登録情報 FormGroup
    this.reginf = this.fb.group({
      // 未精算金管理番号
      kinkoMno: [{ value: this.kinkoMno, disabled: true }],
      // 未精算金履歴番号
      kinkoRrkno: [{ value: this.kinkoRrkno, disabled: true }],
      // 未精算金_更新通番号
      kinkoUpdateSrno: [{ value: this.kinkoUpdateSrno, disabled: true }],
      // 未精算金EX_更新通番号
      kinkoexUpdatesequencenumber: [{ value: this.kinkoexUpdatesequencenumber, disabled: true }],
      // 遷移先未精算ステータスコード
      trantoKinkoStatuscode: [{ value: '', disabled: true }],
    });

    // 充当登録Form FormGroup
    this.sgke072aRequestForm = this.fb.group({
      // リクエスト共通エリア FormGroup
      requestCommon: new UntypedFormGroup({}),
      // 登録情報 FormGroup
      reginf: this.reginf
    });
  }

  /**
   * 初期検索
   * @private
   * @memberof Sgke070dRegistComponent
   */
  private onInitSearch() {
    // sgke071aのリクエスト情報をもつオブジェクトを定義
    this.request071a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        startLine: 0,
        getNumber: 0,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      initialhyojiCndt: {
        kinkoMno: this.kinkoMno,
        kinkoRrkno: this.kinkoRrkno
      }
    };

    // SGKE071A呼び出し
    this.searchService.doSgke071a(this.request071a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.gamenHyojiInfo) {
          this.gamenHyojiInfo = response.gamenHyojiInfo;
          this.jikaiClaimPlndate = this.timeApiService.convertStringToDate(this.gamenHyojiInfo.jikaiClaimPlndate);
        }

        // メッセージを表示
        if (response?.responseCommon?.errors?.length > 0) {
          this.msgEmit.emit(response?.responseCommon?.errors);
        }
      },
      error => {
      }
    );
  }

  /**
   * 充当確定/充当解除ボタン押下時処理
   * @param {boolean} ok
   * @memberof Sgke070dRegistComponent
   */
  onClickApprovalReq(ok: boolean) {
    // 登録情報.遷移先未精算ステータスコードに、押下したボタンの種類に応じた値を設定
    this.reginf.controls.trantoKinkoStatuscode.setValue(ok ? '03' : '01');

    this.clearMessageEmit.emit();

    this.registService.doSgke072a(this.sgke072aRequestForm.getRawValue()).pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response) {

            // メッセージを表示
            if (response?.responseCommon?.errors?.length > 0) {
              this.msgEmit.emit(response?.responseCommon?.errors);
            }

            // SGKE020D_未精算整理詳細画面の再描画
            this.searchEmit.emit();
          }
        },
        error => {
        }
      );
  }

}
